const initialState = {
  object: {},
  loading: true,
  error: null,
};

const LocalDataList = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOCAL_DATA_LIST_START":

      return {
        ...state,
        loading: true,
      };
    case "SET_LOCAL_DATA_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        object: action.payload,
      };
    case "SET_LOCAL_DATA_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default LocalDataList;
